import TranslationCell from './TranslationCell';



export default TranslationCell;
